import React from "react";
import { Chip } from "@mui/material";

export const CustomIconsPlusText = ({
  icon: Icon,
  iconStyles,
  styles,
  text,
  severity,
  blink,
  variant,
  chipStyles,
}) => {
  const resolvedIconStyles = iconStyles || styles;

  const chipIcon = Icon
    ? React.isValidElement(Icon)
      ? Icon
      : React.createElement(Icon, {
          className: blink ? "blink" : "",
          style: resolvedIconStyles,
        })
    : undefined;

  return (
    <Chip
      className="generalCssForStates"
      sx={{ borderRadius: "10px", mx: 0.5, ...(chipStyles || {}) }}
      color={severity || undefined}
      icon={chipIcon}
      variant={variant || "outlined"}
      label={text}
      size="small"
    />
  );
};
